var map = {
	"./acumatica.svg": 36392,
	"./aliexpress.svg": 77368,
	"./bayer.svg": 98968,
	"./bostongene.svg": 61596,
	"./dodo_brands.svg": 65481,
	"./ecco.svg": 38514,
	"./gismart.svg": 50540,
	"./haier.svg": 78592,
	"./indrive.svg": 85864,
	"./leroy_merlin.svg": 10106,
	"./my_games.svg": 3511,
	"./nokian_tyres.svg": 34021,
	"./postgrespro.svg": 64271,
	"./prequel.svg": 41913,
	"./travelpayouts.svg": 67769,
	"./unilever.svg": 53000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14752;